<template>
    <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="initForm"
    width="110rem">
    <div slot="title" class="dialog-title">
        <i class="iconfont icon-jia"></i>
        <p>{{operation=='edit'?'编辑':'创建'}}考核</p>
    </div>
    <div class="content-box">
        <div class="top-box">
            <div class="line-item">
                <div class="item">
                    <p>考核名称</p>
                    <el-input v-model="form.examineName" placeholder="请输入考核名称"></el-input>
                </div>
                <div class="item">
                    <p>答题时间(分)</p>
                    <el-input v-model="form.answerTime" placeholder="请输入答题时间"></el-input>
                </div>
                <div class="item">
                    <p>班级</p>
                    <el-select
                        multiple
                        filterable
                        v-model="form.refClassIds"
                        placeholder="请选择班级">
                        <el-option
                        v-for="item in classOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line-item" style="margin-left: 5rem;">
                <div class="item">
                    <p>开始时间</p>
                    <el-date-picker
                    v-model="form.beginTime"
                    type="datetime"
                    style="width: 19rem;"
                    placeholder="选择开始时间">
                    </el-date-picker>
                </div>
                <div class="item">
                    <p>满分</p>
                    <el-input v-model="form.fullScore" placeholder="请输入满分"></el-input>
                </div>
            </div>
            <div class="line-item" style="margin-left: 5rem;">
                <div class="item">
                    <p>结束时间</p>
                    <el-date-picker
                    type="datetime"
                    v-model="form.endTime"
                    style="width: 19rem;"
                    placeholder="选择结束时间">
                    </el-date-picker>
                </div>
                <div class="item">
                    <p>合格分</p>
                    <el-input v-model="form.passScore" placeholder="请输入合格分"></el-input>
                </div>
            </div>
        </div>
        <div class="add-box">
                <div v-for="(item,index) in examineSoftwareArr" class="add-item" :key="index">
                    <div class="opt" @click="delSoftware(index)">-</div>
                    <div class="add-el" style="margin-left: 3rem;">
                        <p>考核软件</p>
                        <el-select v-model="item.classifyCode" @change="changeCode(item)" placeholder="请选择">
                            <el-option
                            v-for="item in Category"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="add-el" style="margin-left: 3rem;">
                        <el-select v-model="item.refResourceId"  @change="choiceSoftware($event,item)" filterable placeholder="请选择软件">
                            <el-option
                            v-for="item in item.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="add-el" style="margin-left: 3rem;">
                        <p>分数占比</p>
                        <el-input class="number" v-model="item.scoreRatio" :min="0" type="number" placeholder="请输入分数占比"></el-input>
                    </div>
                    <div class="add-el" style="margin-left: 3rem;">
                        <p>总分</p>
                        <el-input disabled class="number" v-model="item.fullScore" type="number" placeholder="请输入总分"></el-input>
                    </div>
                    <div class="add-el"></div>
                </div>
            <div class="btn-box" @click="addExamineSoftware">
                <i class="iconfont icon-jiahao"></i>
                新增考核软件
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <div class="cancel-btn" style="width: 8.8rem;" @click="initForm">取消</div>
        <div class="save" style="width: 8.8rem;margin-left: 3rem;" v-debounce="saveExamine">保存</div>
    </div>
    </el-dialog>
</template>

<script>
import { SaveExamine,UpdateExamine,VirtualSoftwarePageList } from '@/api/examine';
import { CheckSoftware } from '@/api/software';
import { GetClassList } from '@/api/class';
import { getDateTime } from '@/utils/utils';
import { Category,filterVersion,openVirtual } from '@/utils/utils';
    export default {
        data(){
            return {
                dialogVisible:false,
                examineId:'',
                Category:[{label:'全部',value:''},...Category],
                operation:'',
                form:{
                    examineName:'',
                    beginTime:'',
                    endTime:'',
                    refClassIds:[],
                    fullScore:null,
                    passScore:null,
                    answerTime:null
                },
                /**班级可选项 */
                classOptions:[],
                /**软件可选项 */
                softwareOptions:[],
                /**考核软件 */
                examineSoftwareArr:[
                    {
                        "fullScore": 0,
                        "refResourceId": "",
                        "resourceType": 1,
                        "options":this.softwareOptions,
                        "scoreRatio": 100,
                        "classifyCode":''
                    }
                ]
            }
        },
        methods:{
            /**新增考核软件 */
            addExamineSoftware(){
                var obj={
                        "fullScore": 0,
                        "refResourceId": "",
                        "resourceType": 1,
                        "options":this.softwareOptions,
                        "scoreRatio": 0,
                        "classifyCode":''
                    };
                this.examineSoftwareArr.push(obj);
                this.computedRate();
                this.$nextTick(()=>{
                    let dom=document.querySelector('.add-box');
                    dom&&dom.scrollTo({
                        top: dom.clientHeight, 
                        behavior: 'smooth'
                    });
                })
            },
            softwareObj(el){
                let obj={};
                this.examineSoftwareArr.forEach(item=>{
                    if(!item.refResourceId||el.refResourceId==item.refResourceId)return;
                    obj[item.resType]?obj[item.resType].push(item.refResourceId):(obj[item.resType]=[item.refResourceId]);
                })
                return obj;
            },
            /**软件选择校验 */
            verification(item){
                let arr=[];
                this.examineSoftwareArr.forEach(item=>{
                    if(item.refResourceId){
                        arr.push(item.refResourceId);
                    }
                })
                let arr1=[...new Set(arr)];
                if(arr1.length<arr.length){
                        this.$msg({
                            showClose: true,
                            message: "不能选择相同的软件",
                            type: "warning",
                        });
                    return false;
                };
                let obj=this.softwareObj(item);
                if(item.resType=='单机'&&obj[item.resType]&&obj[item.resType].length>=0){
                    this.$msg({
                            showClose: true,
                            message: "单机版的软件最多只能选择一个",
                            type: "warning",
                        });
                    return false;
                }
                for(let key in obj){
                    if(key!=item.resType){
                        if(obj[key]&&obj[key].length>0){
                            this.$msg({
                                showClose: true,
                                message: "只能选择一种类型的软件",
                                type: "warning",
                            });
                            return false;
                        }
                    }
                }
                return true;
            },
            computedRate(){
                let rate=Math.floor(1/this.examineSoftwareArr.length*100);
                this.examineSoftwareArr.forEach((item,index)=>{
                    if(index<this.examineSoftwareArr.length-1){
                        item.scoreRatio=rate;
                    }else{
                        item.scoreRatio=100-rate*(this.examineSoftwareArr.length-1);
                    }
                })
            },
            /**仿真资源校验 */
            checkSoftware(){
                return new Promise(resolve=>{
                    let arr=[];
                    this.examineSoftwareArr.forEach(item=>{
                        if(item.url&&item.resType!='单机'){
                            let obj={};
                            obj.fullPath=openVirtual(item.url);
                            obj.softwareName=item.softwareName;
                            arr.push(obj);
                        }
                    })
                    if(arr.length==0){
                        resolve();
                        return;
                    };
                    CheckSoftware(arr).then(res=>{
                    if(res.code==200){
                        resolve();
                    }
                })
                })
            },
            /**切换所属分类 */
            changeCode(item){
                var params={
                "classifyCode":item.classifyCode,
                "current": 1,
                "ids": [],
                "resourceName": "",
                "size": 9999
                }
                VirtualSoftwarePageList(params).then(res=>{
                    if(res.code==200){
                        item.fullScore=0;
                        item.refResourceId='';
                        item.url='';
                        item.options=res.data.records.map(item=>{
                            return {
                                label:item.softwareName+`(${filterVersion(item.resType).label})`,
                                value:item.id,
                                fullScore:item.fullScore,
                                softwareName:item.softwareName,
                                url:item.url,
                                resType:item.resType
                            }
                        });
                    }
                })
            },

            /**选择软件 */
            choiceSoftware(id,item){
                let el=item.options.find(item=>item.value==id);
                if(!el)return;
                if(el.resType=='网页'){
                    let arr=[
                    {
                        fullPath:openVirtual(el.url),
                        softwareName:el.softwareName
                    }
                    ];
                    CheckSoftware(arr).then(res=>{
                        if(res.code==200){
                            this.selectSoftware(item,el);
                        }else{
                            item.refResourceId='';
                            item.fullScore='';
                            item.softwareName='';
                            item.url='';
                        }
                    }).catch(err=>{
                            item.refResourceId='';
                            item.fullScore='';
                            item.softwareName='';
                            item.url='';
                    })
                }else{
                    this.selectSoftware(item,el);
                }
            },
            selectSoftware(item,el){
                    item.fullScore=el.fullScore;
                    item.softwareName=el.softwareName;
                    item.url=el.url;
                    this.$set(item,'resType',el.resType);
                    if(!this.verification(item)){
                        item.refResourceId='';
                        item.fullScore='';
                        item.softwareName='';
                        item.url='';
                    };
            },
            /**删除考核软件 */
            delSoftware(index){
                this.examineSoftwareArr.splice(index,1);
                this.computedRate();
            },
            /**初始化表单 */
            initForm(){
                this.form={
                    examineName:'',
                    beginTime:'',
                    endTime:'',
                    refClassIds:[],
                    fullScore:null,
                    passScore:null,
                    answerTime:null
                };
                this.examineId='';
                this.examineSoftwareArr=[
                    {
                        "fullScore": 0,
                        "refResourceId": "",
                        "resourceType": 1,
                        "options":[],
                        "scoreRatio": 100,
                        "classifyCode":''
                    }
                ];
                this.dialogVisible=false;
            },
            /**分页查询虚拟仿真软件 */
            virtualSoftwarePageList(){
                var params={
                "classifyCode":"",
                "current": 1,
                "ids": [],
                "resourceName": "",
                "size": 999
                }
                VirtualSoftwarePageList(params).then(res=>{
                    if(res.code==200){
                        this.softwareOptions=res.data.records.map(item=>{
                            return {
                                label:item.softwareName+`(${filterVersion(item.resType).label})`,
                                value:item.id,
                                fullScore:item.fullScore,
                                softwareName:item.softwareName,
                                url:item.url,
                                resType:item.resType
                            }
                        })
                        this.examineSoftwareArr.forEach(item=>{
                            item.options=this.softwareOptions;
                        })
                    }
                })
            },
            /**查询班级列表 */
            getClassList(){
                let params={
                "classCode": "",
                "className": ""
                }
                GetClassList(params).then(res=>{
                    if(res.code==200){
                        this.classOptions=res.data.map(item=>{
                            return {
                                label:item.className,
                                value:item.id
                            }
                        })
                    }
                })
            },
            /**新增考核 */
            saveExamine(){
                this.checkSoftware().then(()=>{
                    let softArr=JSON.parse(JSON.stringify(this.examineSoftwareArr));
                    softArr.forEach(item=>{
                        delete item.url;
                        delete item.softwareName;
                    })
                    let params={
                    "answerTime": this.form.answerTime,
                    "beginTime":getDateTime(new Date(this.form.beginTime).getTime()),
                    "endTime": getDateTime(new Date(this.form.endTime).getTime()),
                    "examineName": this.form.examineName,
                    "examineType": 1,
                    "fullScore":this.form.fullScore,
                    "passScore": this.form.passScore,
                    "refClassIds": this.form.refClassIds,
                    "refResourceDetails":softArr,
                    "repeatBeginTime": "",
                    "repeatCount": 0,
                    "repeatEndTime": ""
                    };
                if(this.operation=='add'){
                    SaveExamine(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "新增考核成功",
                            type: "success",
                        });
                        this.initForm();
                        this.$emit('examine_success');
                    }
                })
                }else{
                    params.id=this.examineId;
                    UpdateExamine(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "修改考核成功",
                            type: "success",
                        });
                        this.initForm();
                        this.$emit('examine_success');
                    }
                })
                }
                })
            }
        },
    }
</script>

<style lang="less" scoped>
.dialog-footer{
    display: flex;
    justify-content: center;
}
.icon-jia{
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    color: #ffffff;
    background-color: var(--blue);
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dialog-title{
    display: flex;
    align-items: center;
    font-weight: 700;
    color: #334681;
    font-weight: 700;
    font-size: 16px;
    &> :nth-child(2){
        margin-left: 1rem;
    }
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.first-content,.second-content{
    display: flex;
    align-items: center;
}
.item{
    display: flex;
    align-items: center;
    &> :nth-child(1){
        color: #8590B3;
        margin-right: 1rem;
    }
}
/deep/.el-input__inner{
    border-radius: 1rem;
    width: 19rem;
}
.top-box{
    padding-bottom: 2.5rem;
    border-bottom: 1px solid #EAEBF0;
    display: flex;
}
.second-content{
    margin-top: 1.8rem;
}
.add-item{
    display: flex;
    align-items: center;
    margin-top: 2rem;
    .opt{
        color: #C2C7D9;
        width: 16px;
        height: 16px;
        border: 1px solid #C2C7D9;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        cursor: pointer;
        margin-left: 3rem;
    }
    .add-el{
        display: flex;
        align-items: center;
        /deep/.el-input__inner{
            width: 21rem;
        }
        & >:nth-child(1){
            color: #334681;
            margin-right: 1rem;
        }
    }
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    margin-left: 6rem;
    margin-top: 3rem;
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.add-box{
    height: 50rem;
    overflow: auto;
}
.line-item{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        &> :nth-child(2){
            margin-top: 1.8rem;
        }
        &> :nth-child(3){
            margin-top: 1.8rem;
        }
    }
    .number{
        /deep/.el-input__inner{
            width: 13rem !important;
        } 
    }
/deep/.el-input__inner{
    min-height: 3rem !important;
}
</style>